import http from '@/services/http';

//-------------------- GETS ----------------------

export async function getFeeTypes(filter) {
  try {
    let res = await http.get('/FeeType');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

//-------------------- PUTS ----------------------

export async function updateFeeType(id, data) {
  try {
    const res = await http.put(`/FeeType/${id}`, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

//-------------------- POSTS ----------------------

export async function createNewFeeType(data) {
  try {
    const res = await http.post('FeeType', data);
    return res;
  } catch (e) {
    console.log(e);
  }
}
